/**
 * Lightweight wrapper around `console.*` that no-ops in production builds.
 * Vite replaces `import.meta.env.DEV` with a literal `true`/`false` at build
 * time so dead-code elimination drops the call site entirely. Used instead of
 * raw `console.*` for any developer-facing logging — keeps prod console clean
 * and avoids accidental leaks of token-adjacent error metadata.
 */
const dev = import.meta.env.DEV

export const log = {
  debug(...args: unknown[]): void {
    if (dev) console.debug(...args)
  },
  info(...args: unknown[]): void {
    if (dev) console.info(...args)
  },
  warn(...args: unknown[]): void {
    if (dev) console.warn(...args)
  },
  error(...args: unknown[]): void {
    if (dev) console.error(...args)
  },
}
